var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "div_1" },
    [
      _c(
        "van-pull-refresh",
        {
          attrs: { "animation-duration": 800, "success-text": "刷新成功" },
          on: { refresh: _vm.onRefresh },
          model: {
            value: _vm.isRefreshing,
            callback: function($$v) {
              _vm.isRefreshing = $$v
            },
            expression: "isRefreshing"
          }
        },
        [
          _c(
            "div",
            [
              null == _vm.ticketList || _vm.ticketList.length < 1
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "center",
                        "padding-top": "25vh",
                        "font-size": "15vw",
                        color: "#EEEEEE"
                      }
                    },
                    [_vm._v(_vm._s(_vm.listEmptyText))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "van-list",
                {
                  staticClass: "ticket_list_0",
                  attrs: {
                    offset: 1,
                    "loading-text": ".",
                    "finished-text": "没有更多了"
                  },
                  on: { load: _vm.listOnBottom },
                  model: {
                    value: _vm.listLoading,
                    callback: function($$v) {
                      _vm.listLoading = $$v
                    },
                    expression: "listLoading"
                  }
                },
                _vm._l(_vm.ticketList, function(t) {
                  return _c(
                    "van-cell",
                    { key: t.orderId, staticStyle: { padding: "0" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "left_div_1",
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.showDetail(t)
                            }
                          }
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "van-multi-ellipsis--l3",
                              staticStyle: { "font-size": "115%" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.showOrHideDetail(t, $event)
                                }
                              }
                            },
                            [_vm._v(_vm._s(t.orderTitle || t.orderId))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "85%",
                                color: "#8b7b8b"
                              }
                            },
                            [
                              _c("MobileTicketStatus", {
                                model: {
                                  value: t.orderStatus,
                                  callback: function($$v) {
                                    _vm.$set(t, "orderStatus", $$v)
                                  },
                                  expression: "t.orderStatus"
                                }
                              }),
                              _vm._v(" "),
                              _c("MobileTicketUser", {
                                attrs: { userId: t.creatorId }
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("创建")]),
                              _vm._v(" "),
                              _c("div", { staticStyle: { float: "right" } }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm._f("ticketTime")(t.createdAt))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              !!t.ticketEventList &&
                              t.ticketEventList.length > 0
                                ? _vm._l(t.ticketEventList, function(e) {
                                    return _c(
                                      "div",
                                      {
                                        key: e.flowId,
                                        staticClass: "ticketEvent_1"
                                      },
                                      [
                                        _c("MobileTicketUser", {
                                          attrs: { userId: e.dealUserId }
                                        }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(e.operateContent))
                                        ]),
                                        _vm._v(" "),
                                        e.assignUserId
                                          ? _c(
                                              "span",
                                              [
                                                _vm._v(
                                                  "\n                    给\n                    "
                                                ),
                                                _c("MobileTicketUser", {
                                                  attrs: {
                                                    userId: e.assignUserId
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("ticketTime")(e.createdAt)
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        e.orderRemark
                                          ? _c("span", {
                                              staticClass: "plain-text-remark",
                                              staticStyle: { color: "#000" },
                                              domProps: {
                                                textContent: _vm._s(
                                                  "：" +
                                                    e.orderRemark.remarkContent
                                                )
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  })
                                : _vm._e()
                            ],
                            2
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "right_btn_3",
                          on: {
                            click: function($event) {
                              return _vm.goDetail(t)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "right_btn_4" }, [
                            _vm._v("详情")
                          ])
                        ]
                      )
                    ]
                  )
                }),
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d53a0b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d53a0b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile-ticket/MobileTicketList.vue
// module id = 644
// module chunks = 75